import { useEffect, useImperativeHandle, useRef, useState } from 'react';
import '../styles/Reel.scss';
// import gsap from 'gsap';

import BARIMG from '../assets/flat/symb-bar.png';  // .jpg';  // need this one to be transparent because of scale effect.
import COINIMG from '../assets/flat/symb-coin.jpg';
import HATIMG from '../assets/flat/symb-hat.jpg';
import SHOEIMG from '../assets/flat/symb-shoe.jpg';
import SEVENIMG from '../assets/flat/symb-seven.jpg';
import BELLIMG from '../assets/flat/symb-bell.jpg';
import DICEIMG from '../assets/flat/symb-dice.jpg';
import LEMONIMG from '../assets/flat/symb-lemon.jpg';
import CHERRYIMG from '../assets/flat/symb-cherry.jpg';

import BARIMG_BLUR from '../assets/blur/symb-bar.jpg';
import COINIMG_BLUR from '../assets/blur/symb-coin.jpg';
import HATIMG_BLUR from '../assets/blur/symb-hat.jpg';
import SHOEIMG_BLUR from '../assets/blur/symb-shoe.jpg';
import SEVENIMG_BLUR from '../assets/blur/symb-seven.jpg';
import BELLIMG_BLUR from '../assets/blur/symb-bell.jpg';
import DICEIMG_BLUR from '../assets/blur/symb-dice.jpg';
import LEMONIMG_BLUR from '../assets/blur/symb-lemon.jpg';
import CHERRYIMG_BLUR from '../assets/blur/symb-cherry.jpg';

import IDLEIMG from '../assets/symb-idle.jpg';
// import INSTRUCTIMG from '../assets/symb-instruct.jpg';

export const IDLE = 'i';
const BAR = 'b';
const COIN = 'c';
const HAT = 'h';
const SHOE = 's';
const SEVEN = 'v';
const BELL = 'e';
const DICE = 'd';
const LEMON = 'l';
const CHERRY = 'r';
export const SYMBOLS = [ BAR, HAT, LEMON, DICE, SEVEN, BELL, SHOE, COIN, CHERRY ];
const SYMBOLIMG = [ BARIMG, HATIMG, LEMONIMG, DICEIMG, SEVENIMG, BELLIMG, SHOEIMG, COINIMG, CHERRYIMG ];
const BLURIMG = [ BARIMG_BLUR, HATIMG_BLUR, LEMONIMG_BLUR, DICEIMG_BLUR, SEVENIMG_BLUR, BELLIMG_BLUR, SHOEIMG_BLUR, COINIMG_BLUR, CHERRYIMG_BLUR ];
const BLURTHRESHOLD = -2;

const NOSPIN = 0;
const STRAIGHTSPIN = 1;
const TARGETEDSPIN = 2;
const BACKSPIN = 3;

export default function Reel( {pos,ref} ){

    // const [ r, setR ] = useState(0);
    // const [ vel, setVel ] = useState(0);

    const requestRef = useRef();
    const loopRef = useRef();
    const r = useRef();
    const vel = useRef();

    const [ spinMode, setSpinMode ] = useState(NOSPIN);
    const [ spinTarget, setSpinTarget ] = useState(0);
    const [ isReset, setIsReset ] = useState(false);

    const [ currentI, setCurrentI ] = useState(-1);

    const [ icons, setIcons ] = useState( SYMBOLIMG );

    useEffect( ()=> { // start on random symbol.
        const i = Math.floor( Math.random() * SYMBOLS.length );
        // setR( i * 40 );
        r.current = -i*40;
        vel.current = 0;

        loopRef.current.style.transform = `translateZ(-30vw) rotateX(${r.current}deg)`;
    },[]);

    useEffect( ()=> {
        // console.log('spinMode',spinMode);
        if (spinMode===STRAIGHTSPIN) requestRef.current = requestAnimationFrame(spinUpdate);
        if (spinMode===TARGETEDSPIN) requestRef.current = requestAnimationFrame(spinUpdate);
        if (spinMode===NOSPIN) {
            cancelAnimationFrame(requestRef.current); 
            requestAnimationFrame(backspinUpdate);
        }
    }, [spinMode] );

    useImperativeHandle( ref, ()=>({
        rollback() {

        },
        spin() {
            console.log('spin',pos);
            // gsap.ticker.add(spinUpdate);
            vel.current = 1;
            r.current %= 360;

            setSpinMode( STRAIGHTSPIN );
            // requestRef.current = requestAnimationFrame(spinUpdate);
        },
        stop( forcedResult, match ) {
            
            setIcons( SYMBOLIMG ); // toggle back to normal icons

            // gsap.ticker.remove(spinUpdate);
            let rr = r.current%360;
            rr = Math.floor(rr/40) * 40;
            
            // FORCE LOGIC
            if (forcedResult===1) {
                rr = -160;
            } else if (forcedResult===2) {
                rr = -40; 
            } else if (forcedResult===3) {
                rr = 0;
            } else if (forcedResult===-1) {
                // pick a random icon that does not match.
                const others = [ ...SYMBOLS ]
                others.splice( SYMBOLS.indexOf(match), 1);
                const randicon = others[ Math.floor( Math.random()*others.length ) ];
                console.log('force non-match', match, randicon);
                rr = -40 * SYMBOLS.indexOf(randicon);
            }

            

            r.current = rr-6; // overshoot target a bit to allow bounceback
            vel.current = 0;

            const i = getIconForPos(rr);
            
            console.log('stop',pos,i);

            setSpinMode( NOSPIN );
            // cancelAnimationFrame(requestRef.current);
            // requestAnimationFrame(backspinUpdate);

            return i;
        },
        idle() {
            let i = -Math.floor(r.current/40);
            i %= SYMBOLS.length;
            const currenticon = icons[ i ];
            // console.log('idle',i,currenticon===IDLEIMG);
            if (currenticon===IDLEIMG) {
                let nreel = [...icons];
                // nreel[ (i+1)%SYMBOLS.length ] = IDLEIMG; // 
                nreel[ (i+2)%SYMBOLS.length ] = IDLEIMG;
                setIcons(nreel);

                i = (i+1)%SYMBOLS.length;
            } else {
                i += 2;
                // i %= SYMBOLS.length;

                // console.log('idle',i,r.current);
                let nreel = [...SYMBOLIMG]; // clone original array
                nreel[ i%SYMBOLS.length ] = IDLEIMG;
                nreel[ (i+1)%SYMBOLS.length ] = IDLEIMG;
                nreel[ (i+2)%SYMBOLS.length ] = IDLEIMG;
                setIcons( nreel );

                i = (i+1)%SYMBOLS.length;
            }
            // console.log('go',i);
            

            vel.current = 0;
            // requestRef.current = requestAnimationFrame(spinUpdate);

            setIsReset( false );
            setSpinTarget( i );
            setSpinMode( TARGETEDSPIN );
            // setIsIdle(true);
        },
        reset() {
            // reset icons
            // let i = -Math.floor(r.current/40);
            // i += 2;
            // // i %= SYMBOLS.length;

            // // console.log('reset',i,r.current);
            // let nreel = [...icons]; // clone current array
            // nreel[ i%SYMBOLS.length ] = SYMBOLIMG[ i%SYMBOLS.length ];
            // nreel[ (i+1)%SYMBOLS.length ] = SYMBOLIMG[ (i+1)%SYMBOLS.length ];
            // nreel[ (i+2)%SYMBOLS.length ] = SYMBOLIMG[ (i+2)%SYMBOLS.length ];
            // setIcons( nreel );

            let i = Math.floor( Math.random()*SYMBOLS.length );
            // i += 2;
            // i %= SYMBOLS.length;

            // console.log('reset',i,r.current);
            let nreel = [ ...SYMBOLIMG ]; // clone original array
            nreel[ i%SYMBOLS.length ] = IDLEIMG;
            nreel[ (i+1)%SYMBOLS.length ] = IDLEIMG;
            nreel[ (i+2)%SYMBOLS.length ] = IDLEIMG;
            setIcons( nreel );

            r.current = -(i+1)*40;
            vel.current = 0;

            setIsReset( true );
            setSpinTarget( (i+4)%SYMBOLS.length );
            setSpinMode( TARGETEDSPIN );

            // setIsIdle(false);
        }
    }));

    const getIconForPos = (n) => {
        let i = n/40;
        i %= SYMBOLS.length;
        // console.log(i);
        return SYMBOLS[-(i)];
    }

    function spinUpdate() {
        // console.log('spinUpdate');
        // console.log(r,isIdle,idleStart);

        let stopSpinning = false;
        
        if (spinMode===STRAIGHTSPIN) {
            vel.current -= .1;
            
            if (vel.current < BLURTHRESHOLD) { // going fast
                if (icons[0]===SYMBOLIMG[0]) { // not blur icons
                    setIcons( BLURIMG );
                }
            }

        } else if (spinMode===TARGETEDSPIN) {
            const rr = r.current % 360;
            let i = -Math.round(rr/40);

            if (i===spinTarget) {
                vel.current *= .95;

                // console.log(rr, spinTarget*40); 
                if ( (spinTarget*40) + rr < -2 ) {
                    // console.log(rr, spinTarget*40);
                    // cancelAnimationFrame(requestRef.current);
                    setSpinMode( NOSPIN );
                    vel.current = -rr - (spinTarget*40);
                    stopSpinning = true;
                    // return;

                    if (isReset) setIcons( SYMBOLIMG );
                }

                // cancelAnimationFrame(requestRef.current);
                // vel.current = 0;
                // return;
            } else {
                vel.current -= .1;
            }
        }
        
        r.current += vel.current;
        loopRef.current.style.transform = `translateZ(-30vw) rotateX(${r.current}deg)`;

        if (!stopSpinning) requestRef.current = requestAnimationFrame(spinUpdate);
    }
    function backspinUpdate(){
        
        let rr = r.current%360;
        let tr = Math.floor(rr/40) * 40;

        let dr = rr - tr;
        // console.log('backspin',rr,tr,dr); // backspin -245.1 -280 34.900000000000006
        r.current = rr + (dr*.04);

        // loopRef.current.style.transform = `translateZ(-30vw) rotateX(${r.current}deg)`;

        if (Math.abs(dr)>5) { 
            loopRef.current.style.transform = `translateZ(-30vw) rotateX(${r.current}deg)`;
            requestAnimationFrame(backspinUpdate);
        } else {
            setCurrentI(-Math.floor(r.current/40));
            r.current = tr;
            loopRef.current.style.transform = `translateZ(-30vw) rotateX(${r.current}deg)`;
        }

    }
    
    return (
        <div className="reel-container">
            <div className="reel">
                <div className="loop" ref={loopRef}>
                    { icons.map( (s,i) => <img key={i} alt={s} src={ icons[i] } style={{"--i":i}} className={currentI===i?'current':''} /> ) }
                    { icons.map( (s,i) => <div key={i} style={{"--i":i}} /> ) }
                </div>
            </div>
        </div>
    );
}